<template>
    <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="page-title">Pending Car Park Claim List</h3>
                </div>
            </div>
        </div>
        <!-- /Page Header -->

        <!-- Table List -->
        <div class="row">
            <div class="col-md-12">
                <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1 mt-4">

                    <table class="table table-bordered custom-table mb-0">
                        <thead class="thead-light">
                            <tr>
                                <th class="text-center action-column">Action</th>
                                <th class="group-column">Emp ID</th>
                                <th>Emp Name</th>
                                <th>Month</th>
                                <th>Year</th>
                                <th>Status</th>
                                <th>Remarks</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(record, index) in records">
                                <td class="action-column text-center">
                                    <router-link :to="{ name: 'carparkClaimFormView', params: { id: record.Id } }">
                                        <a class="btn btn-secondary"><span>View</span></a>
                                    </router-link>
                                </td>
                                <td class="group-column">{{ record.EmployeeID }}</td>
                                <td class="group-column">{{ record.EmployeeName }}</td>
                                <td class="group-column">{{ record.Month | monthInText }}</td>
                                <td class="group-column">{{ record.Year }}</td>
                                <td class="group-column">{{ record.Status }}</td>
                                <td class="group-column">{{ record.Remarks }}</td>
                            </tr>

                            <tr v-if="records && !records.length">
                                <td colspan="7" class="text-center">{{ this.noRecordText }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- /Table List -->
    </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";

export default {
    data() {
        return {
            noRecordText: config.NO_RECORD_TEXT,
            records: null,
        };
    },

    filters: {
        monthInText(val) {
            if (!val) return "";
            let month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            return month[val - 1];
        }
    },

    computed: {
        token() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Token;
        },
        role() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Role;
        },
    },

    methods: {
        getManagerCarparkClaim() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            let param = {
                Token: this.token,
                UserId: data.Id,
                Status: config.CARPARKCLAIM_STATUS_PENDING
            };
            this.$store.state.isLoading = true;
            API.getManagerCarparkClaim(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        if (response.data.isEmpty) {
                            this.records = [];
                        }
                        else {
                            this.records = response.data.record;
                        }
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.message, { icon: "error" });
                });
        }
    },

    created() {
        this.getManagerCarparkClaim();
    },
}
</script>

<style scoped>
.group-column {
    width: 12%;
}
</style>


// WEBPACK FOOTER //
// src/components/Carpark/PendingList.vue